// Shared policy for explicit scenario transitions on web and native apps.
export function createAdFrequency({ storage, now = Date.now } = {}) {
  const key = 'kickviz-ad-frequency-v1';
  let state = { actions: 0, shown: [], started: now() };
  try { const saved = JSON.parse(storage?.getItem(key)); if (saved && Array.isArray(saved.shown) && Number.isFinite(saved.started)) state = saved; } catch {}
  const persist = () => { try { storage?.setItem(key, JSON.stringify(state)); } catch {} };
  return {
    opportunity() { state.actions = Math.min(3, (Number(state.actions) || 0) + 1); persist(); },
    ready() { const time = now(); state.shown = state.shown.filter(t => t > time - 3600000 && t <= time); return state.actions >= 3 && time - (state.shown.at(-1) ?? state.started) >= 120000 && state.shown.length < 6; },
    record() { state.actions = 0; state.shown.push(now()); persist(); }
  };
}
